import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: '/renegociar',
  name: 'Renegociacao',
  component: function component() {
    return import(/* webpackChunkName: "publico" */'./pages/Renegociacao');
  },
  meta: {
    titulo: 'Renegociação',
    precisaAutenticacao: false,
    cabecalho: false,
    rodape: false,
    redirecionamento: true
  }
}];